import React, { useEffect, useState } from "react";
import {
  CustomTableContainer,
  CustomTableHead,
  ExportText,
  MenuItemLabel,
  TabTitle,
} from "../publications.styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import InputMask from "react-input-mask";
import Calendar from "assets/icons/calendar.svg";
import { SearchButton } from "components/searchButton";
import { ReactComponent as SearchIcon } from "assets/icons/search-white.svg";
import { ReactComponent as Document } from "assets/icons/services-icons/document.svg";
import { ReactComponent as Options } from "assets/icons/options.svg";
import { ReactComponent as FileView } from "assets/icons/file-view.svg";
import { ACTION_TYPES, usePublicationsDispatch, usePublicationsState } from "../context/publications-context";
import { Pagination } from "@material-ui/lab";
import { usePublicationsController } from "../context/publications-controller";
import { IPublicationPagedReqeust } from "models/request/publication-paged-request copy";
import { IPublicationPagedResponse } from "models/response/publication-paged-response";
import dayjs from "dayjs";
import { IPublisingVehicleListReponse } from "models/response/publishing-vehicle-list-repsonse";


export const PublicationTabContent = ({ categoryId, description }: { categoryId: number, description: string }) => {
  const { publicationRequest, publicationsResponse, publisingVehicles } = usePublicationsState();
  const { listPublication, handleOnChange, exportData } = usePublicationsController();
  const publicationsDispatch = usePublicationsDispatch();
  const [pubVehicle, setPubVehicle] = useState<string>("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [publication, setPublication] = useState<IPublicationPagedResponse | null>(null);
  const [open, setOpen] = React.useState(false);


  const handleClose = () => {
    setOpen(false);
  };

  const handlePageClick = (event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    (async () => {
      await listPublication({ ...publicationRequest, page: value - 1 }, true);
    })();
  };
  const showDetails = () => {
    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Detalhes da Publicação
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography><strong>Data da Publicação:</strong> {dayjs(publication?.publicationDate).format("DD/MM/YYYY")}</Typography>
              <Typography><strong>Descrição:</strong> {publication?.description}</Typography>
              <Typography><strong>Republicação:</strong> {publication?.republication ? "Sim" : "Não"}</Typography>
              {publication?.number !== null && publication?.number !== null &&
                <Typography><strong>Número:</strong> {publication?.number}</Typography>
              }
              {publication?.biddingComission !== null && publication?.biddingComission !== null && publication?.biddingComission !== undefined  &&
                <Typography><strong>Comissão Licitação:</strong> {publication?.biddingComission}</Typography>
              }
              {publication?.presidentBiddingComission !== null && publication?.presidentBiddingComission !== null && publication?.biddingComission !== undefined  &&
                <Typography><strong>Presidente Comissão Licitação:</strong> {publication?.presidentBiddingComission}</Typography>
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      var request = { categoryId, page: 0, pageSize: 20 } as IPublicationPagedReqeust;
      publicationsDispatch({
        type: ACTION_TYPES.setPublicationRequest,
        payload: request,
      });
      await listPublication(request, true);

    })();

  }, []);

  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>, publication: IPublicationPagedResponse) => {
    setPublication(publication);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => setAnchorEl(null);

  return (
    <>
      <Grid item xs={12}>
        <TabTitle>{description}</TabTitle>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                value={publicationRequest.term}
        variant="outlined"
                name="text-field-term"
                id="text-field-term"
                fullWidth
                onChange={(e) => handleOnChange(e, 2)}
                label="Buscar por"
              />
            </Grid>
            <Grid item xs={12} md>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-outlined-label">
                  Veículo publicação
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="select-publishing-vehicle-id"
                  name="select-publishing-vehicle-id"
                  value={publicationRequest.publishingVehicleId !== null ? publicationRequest.publishingVehicleId : ""}
                  onChange={(e) => handleOnChange(e, 2)}
                  label="Veículo publicação"
                >
                  <MenuItem value="">TODOS</MenuItem>
                  {publisingVehicles?.map((item: IPublisingVehicleListReponse, index: number) => (
                    <MenuItem value={item.id}>{item.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md>
              <InputMask
                mask={"99/99/9999"}
                name="text-field-start-date"
                onChange={(e) => handleOnChange(e, 2)}
                value={publicationRequest.startDate !== null ? publicationRequest.startDate : ""}
              >
                {(inputProps) => (
                  <TextField
    variant="outlined"

                    fullWidth
                    label="Data início"

                    placeholder="dd/mm/aaaa"
                    {...inputProps}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <img src={Calendar} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs={12} md>
              <InputMask
                mask={"99/99/9999"}
                name="text-field-end-date"
                onChange={(e) => handleOnChange(e, 2)}
                value={publicationRequest.endDate != null ? publicationRequest.endDate : ""}
              >
                {(inputProps) => (
                  <TextField
               variant="outlined"

                    fullWidth
                    label="Data fim"
                    placeholder="dd/mm/aaaa"
                    {...inputProps}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <img src={Calendar} alt="" />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              </InputMask>
            </Grid>
            <Grid item xs="auto">
              <SearchButton onClick={() => (async () => {
                await listPublication({ ...publicationRequest, categoryId: categoryId }, true);

              })()}>
                <SearchIcon /> Consultar
              </SearchButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            spacing={2}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item xs="auto">
              <ExportText>Exportar</ExportText>
            </Grid>
            <Grid item xs="auto">
              <Button startIcon={<Document />}
                onClick={() => (async () => {
                  await exportData(1, "odt");

                })()}>ODT</Button>
            </Grid>
            <Grid item xs="auto">
              <Button startIcon={<Document />} onClick={() => (async () => {
                await exportData(1, "json");

              })()}>JSON</Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <CustomTableContainer>
            <Table>
              <CustomTableHead>
                <TableRow>
                  <TableCell width="12%">Data Publicação</TableCell>
                  <TableCell width="12%">Número</TableCell>
                  <TableCell width="60%">Descrição</TableCell>
                  <TableCell width="auto">Republicação</TableCell>
                  <TableCell width={60}>Opções</TableCell>
                </TableRow>
              </CustomTableHead>
              <TableBody>
                {publicationsResponse &&
                  publicationsResponse?.items?.map((item: IPublicationPagedResponse) => (
                    <TableRow key={item.id}>
                      <TableCell>{dayjs(item.publicationDate).format("DD/MM/YYYY")}</TableCell>
                      <TableCell>{item.number}</TableCell>
                      <TableCell>{item.description}</TableCell>
                      <TableCell>{item.republication ? "Sim" : "Não"}</TableCell>
                      <TableCell>
                        <IconButton onClick={(e) => handleClickMenu(e, item)}>
                          <Options />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </CustomTableContainer>
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Pagination size="large" variant="outlined" shape="rounded" onChange={handlePageClick} count={publicationsResponse.pageCount} color="primary" />
          </Grid>
        </Grid>
      </Grid>
      {showDetails()}
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={() => {
          if (publication !== null)
            window.open(publication.fileUrl, "_blank");
          handleCloseMenu();
        }}>
          <FileView /> <MenuItemLabel>Ver arquivo</MenuItemLabel>
        </MenuItem>
        <MenuItem onClick={() => {
          if (publication !== null)
            setOpen(true);

          handleCloseMenu();
        }}>
          <Document /> <MenuItemLabel>Detalhes</MenuItemLabel>
        </MenuItem>
      </Menu>
    </>
  );
};
